import CasinosListing from "../../components/client-side/casinos/CasinosListing";

const CasinosPage = () => {
  return (
    <div className="min-h-screen bg-background dark:bg-darkbg text-text dark:text-textDark transition-colors duration-300">
      <CasinosListing />
    </div>
  );
};

export default CasinosPage;
